import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ContentEditableDirective} from './contenteditable.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [ContentEditableDirective],
  exports: [ContentEditableDirective],
})
export class ContenteditableModule {}
